import { render, staticRenderFns } from "./TicketCards.vue?vue&type=template&id=2ab1a363&"
import script from "./TicketCards.vue?vue&type=script&lang=js&"
export * from "./TicketCards.vue?vue&type=script&lang=js&"
import style0 from "./TicketCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports